import { Camp } from '../types';

const loadCampImages = (campFolder: 'aldos_camp' | 'deckies_camp'): string[] => {
  const toSortedImages = (ctx: { keys: () => string[]; (key: string): unknown }) =>
    ctx
      .keys()
      .map((k) => String(ctx(k)))
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));

  // CRA/Webpack runtime
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const req: any = require;

  switch (campFolder) {
    case 'aldos_camp': {
      const ctx = req.context('../assets/aldos_camp', false, /\.(png|jpe?g|gif|webp)$/i);
      return toSortedImages(ctx);
    }
    case 'deckies_camp': {
      const ctx = req.context('../assets/deckies_camp', false, /\.(png|jpe?g|gif|webp)$/i);
      return toSortedImages(ctx);
    }
    default:
      return [];
  }
};

export const camps: Camp[] = [
  {
    id: 'camp-1',
    name: "Aldo's Camp",
    description: 'A stunning oceanfront camp with panoramic ocean views. Wake up to the sound of seabirds and the ocean. Perfect for a group of mates, research team or family to explore the Abrolhos.',
    location: 'Basile Island',
    pricePerNight: 600,
    maxGuests: 6,
    amenities: [
      'Ocean view',
      'Bucket shower',
      'Kitchen',
      'Fresh water',
      'BBQ area',
      'Internet',
    ],
    images: loadCampImages('aldos_camp'),
    position: { lat: -28.90, lng: 113.95 },
  },
  {
    id: 'camp-2',
    name: "Deckie's Camp",
    description: 'A private self contained retreat toward the back of the island, perfect for a couple.',
    location: 'Basile Island',
    pricePerNight: 400,
    maxGuests: 2,
    amenities: [
      'Ocean view',
      'Bucket shower',
      'Kitchen',
      'Fresh water',
      'BBQ area',
      'Internet',
      'Lounge room',
    ],
    images: loadCampImages('deckies_camp'),
    position: { lat: -28.72, lng: 113.78 },
  }
];

